import { useShallow } from 'zustand/react/shallow';
import { useAuth } from './auth';
import { usePrice } from './price';

export const useAddress = () => useAuth(useShallow((state) => state.address));

export const usePriceByPairIndex = (pairIndex: string | number) =>
    usePrice(
        useShallow((state) => state.data[String(pairIndex)] ?? { price: '', price24h: '' })
    );
